var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49998 9.99725H4.49999V9.995C4.49999 5.86535 7.86493 2.5 12 2.5C16.1348 2.5 19.5 5.86514 19.5 10L19.5 10.0023C19.5136 13.0265 17.6244 15.9057 15.6416 18.0779C14.6595 19.1538 13.675 20.0339 12.9355 20.6453C12.5661 20.9506 12.2589 21.1881 12.0449 21.3485C12.0289 21.3605 12.0134 21.3721 11.9985 21.3832C11.3579 20.913 9.78805 19.6994 8.24558 17.9976C6.30441 15.8559 4.48635 13.0281 4.49998 9.99725ZM7.49999 10C7.49999 12.4861 9.51385 14.5 12 14.5C14.4861 14.5 16.5 12.4861 16.5 10C16.5 7.51386 14.4861 5.5 12 5.5C9.51385 5.5 7.49999 7.51386 7.49999 10Z",
    stroke: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOutlined);
export default __webpack_public_path__ + "static/media/locationOutlined.f97e0f8b.svg";
export { ForwardRef as ReactComponent };